export default __webpack_public_path__ + "images/feedback-tick-icon.30b01d83207d6624a1a26f9b55b4a1b6.svg";